import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { SocialLoginComponent } from './sociallogin/social-login.component';
import { LoginComponent } from './login.component';
import { routing } from './login.routes';
import { AuthComponent } from './auth/auth.component';
import { ResetComponent } from './reset/reset.component';
import { ForgotComponent } from './forgot/forgot.component';



@NgModule({

    imports: [
        routing,
        SharedModule
    ], entryComponents:[LoginComponent,ResetComponent,ForgotComponent],
    declarations: [LoginComponent, SocialLoginComponent, AuthComponent,ResetComponent,ForgotComponent]
})
export class LoginModule { }



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/+login/login.module.ts